import React from "react";
import { Spinner } from "@heroui/react";

interface HeroSpinPropsProps {
  label?: string;
  color?:
    | "default"
    | "primary"
    | "secondary"
    | "success"
    | "warning"
    | "danger";
  size?: "sm" | "md" | "lg";
  labelColor?:
    | "foreground"
    | "primary"
    | "secondary"
    | "success"
    | "warning"
    | "danger";
  className?: string;
}

/**
 *
 * @param param0 label, color, size, labelColor
 * @returns NextUI Spinner
 */
const HeroSpin: React.FC<HeroSpinPropsProps> = ({
  size = "lg",
  color,
  labelColor,
  label,
  className,
}) => {
  return (
    <Spinner
      label={label}
      size={size}
      color={color}
      labelColor={labelColor}
      className={className}
    />
  );
};

export default HeroSpin;
